export class PictureUtil {

  public static readonly WEB_MAX_WIDTH = 1200;
  public static readonly WEB_MAX_HEIGHT = 1200;

  public static readonly THUMBNAIL_WIDTH = 352;
  public static readonly THUMBNAIL_MAX_WIDTH = 480;

}
